import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Sun } from "lucide-react";

export default function Footer() {
  const cols = [
    {
      title: "Discover",
      links: [
        { to: "/events", label: "Events" },
        { to: "/experiences", label: "Experiences" },
        { to: "/guides", label: "Guides" },
        { to: "/directory", label: "Directory" },
      ],
    },
    {
      title: "Plan",
      links: [
        { to: "/concierge", label: "AI Concierge" },
        { to: "/trip-planner", label: "Trip Planner" },
        { to: "/dashboard", label: "My Account" },
      ],
    },
    {
      title: "Business",
      links: [
        { to: "/register", label: "List your business" },
        { to: "/events", label: "Submit an event" },
        { to: "/concierge", label: "Corporate concierge" },
      ],
    },
  ];
  return (
    <footer className="relative mt-32 bg-[color:var(--ocean)] text-[color:var(--sand)] grain overflow-hidden">
      {/* sun & wave accents */}
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[color:var(--mango)] opacity-25 blur-2xl" />
      <div className="absolute bottom-0 -left-20 w-96 h-96 rounded-full bg-[color:var(--coral)] opacity-15 blur-3xl" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 grid grid-cols-1 md:grid-cols-12 gap-12 relative z-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-2">
            <Sun size={26} className="text-[color:var(--mango)]" />
            <h3 className="font-display text-[2.6rem] leading-none">
              Hey <span className="font-hand text-[3rem] text-[color:var(--coral)]">GC</span>
            </h3>
          </div>
          <p className="mt-6 text-[0.95rem] leading-relaxed max-w-xs text-[color:var(--sand)]/80">
            The friendliest way to do the Gold Coast. Made with sand between our toes and salt in our hair.
          </p>
          <div className="mt-8 flex gap-3">
            <a href="#" aria-label="Instagram" className="w-11 h-11 rounded-full border-2 border-white/25 grid place-items-center hover:bg-[color:var(--coral)] hover:border-[color:var(--coral)] transition-colors">
              <Instagram size={16} />
            </a>
            <a href="#" aria-label="Facebook" className="w-11 h-11 rounded-full border-2 border-white/25 grid place-items-center hover:bg-[color:var(--coral)] hover:border-[color:var(--coral)] transition-colors">
              <Facebook size={16} />
            </a>
            <a href="#" aria-label="YouTube" className="w-11 h-11 rounded-full border-2 border-white/25 grid place-items-center hover:bg-[color:var(--coral)] hover:border-[color:var(--coral)] transition-colors">
              <Youtube size={16} />
            </a>
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title} className="md:col-span-2">
            <h4 className="text-[0.72rem] uppercase tracking-[0.22em] text-[color:var(--mango)] mb-6 font-bold">{c.title}</h4>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-[0.95rem] opacity-90 hover:opacity-100 hover:text-[color:var(--coral)] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="md:col-span-2">
          <h4 className="text-[0.72rem] uppercase tracking-[0.22em] text-[color:var(--mango)] mb-6 font-bold">Insider</h4>
          <p className="text-[0.85rem] opacity-80 mb-3">Weekly weekend guide. No spam.</p>
          <form className="flex gap-2">
            <input
              type="email"
              placeholder="your@email.com"
              className="flex-1 bg-white/10 border border-white/25 rounded-full px-4 py-2 text-sm placeholder:text-white/50 focus:border-[color:var(--mango)] outline-none"
            />
            <button type="button" className="btn-pill btn-primary text-sm px-4">Join</button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10 relative z-10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 text-xs opacity-70 flex flex-col md:flex-row justify-between gap-2">
          <span>© 2026 Hey GC. Gold Coast, Queensland.</span>
          <span>Acknowledging the Yugambeh people, traditional custodians of this land.</span>
        </div>
      </div>
    </footer>
  );
}
